export enum FilterIdentity {
  VERTICAL = 'Vertical',
  WEEK = 'Week',
  MARKETPLACE = 'Marketplace',
  SKILL = 'Skill',
  CHANNEL = 'Channel',
  SEGMENT = 'Segment',
}

export const DEFAULT_ALL = 'ALL';

export interface FilterProps {
  label: string;
  value: string;
  filterOptions: string[];
  setValue: any;
  identity: FilterIdentity;
  page: string;
  ccxDetailsPage?: string;
}
